import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomContainer from "views/Container/CustomContainer";
import Abf from './Abf';
import About from "./About";
import CarouselAbf from "./CarouselAbf";
import FullScreenHeroWithLogoGrid from "./FullScreenHeroWithLogoGrid";
import GalleryAbf from "./GalleryAbf";

const GoogleSheetParser = () => {
  const { t } = useTranslation();

  return (
    <CustomContainer container={false}>
      <FullScreenHeroWithLogoGrid />
      <Abf />
      <GalleryAbf />
      <Box component="div" sx={{ display: { xs: "none", sm: "block" } }}>
        <CarouselAbf />
      </Box>
      <About />
    </CustomContainer>
  );
};

export default GoogleSheetParser;
